export type BasicMessage = {
  role?: "user" | "assistant";
  sender?: "user" | "ai";
  content?: string;
  text?: string;
};

function normalizeRole(msg: BasicMessage): "User" | "Assistant" {
  const role = (msg.role || (msg.sender === "ai" ? "assistant" : msg.sender)) as
    | "user"
    | "assistant"
    | undefined;
  return role === "assistant" ? "Assistant" : "User";
}

function getText(msg: BasicMessage): string {
  return String(msg.content ?? msg.text ?? "").trim();
}

/**
 * Convert a conversation into shareable plain text.
 * Format: "Role: content" separated by blank lines. Optionally truncates very long text.
 */
export function formatConversationText(
  messages: BasicMessage[],
  options?: { maxChars?: number }
): string {
  const maxChars = options?.maxChars ?? 20000; // Guard against extremely long payloads
  const lines: string[] = [];
  for (const m of messages || []) {
    const text = getText(m);
    if (!text) continue;
    lines.push(`${normalizeRole(m)}:\n${text}`);
  }
  let output = lines.join("\n\n").trim();
  if (output.length > maxChars) {
    output = output.slice(0, Math.max(0, maxChars - 15)).trimEnd() + "\n\n... [truncated]";
  }
  return output || "";
}

export default formatConversationText;
